module.exports = __webpack_public_path__ + "static/media/noEventImage.ebb6d182.svg";